import {Component, ErrorInfo} from 'react'

import {isAxiosError} from 'axios'

import {NotFoundError} from '$commons/errors/myAssetErrors'
import ErrorPage, {ERROR_TYPE} from '$pages/_error'
import {sendNeloToBFF} from '$services/nelo'
import {NeloLogLevel} from '$share/constants/nelo'
import logger from '$utils/logger'

type ErrorBoundaryProps = React.PropsWithChildren<object>
interface ErrorBoundaryState {
    error: Error | null
}

const DEFAULT_STATE: ErrorBoundaryState = {
    error: null,
}
export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props)
        this.state = {...DEFAULT_STATE}
    }

    // 컴포넌트 렌더링 과정 중 발생한 에러 캐치
    static getDerivedStateFromError(error: Error) {
        logger.error(error)
        return {error}
    }

    override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        logger.error(`${error?.message}`, errorInfo)
        sendNeloToBFF({
            logLevel: NeloLogLevel.Error,
            logType: 'error-boundary',
            log: {
                name: error.name,
                message: error.message,
                pageUrl: window.location.href,
                ...(isAxiosError(error) ? {apiUrl: `${error.config?.baseURL}${error.config?.url}`} : {}),
                ...(error?.stack ? {stack: error.stack} : {}),
            },
        })
        this.setState({error})
    }

    render() {
        const {error} = this.state

        if (error) {
            const errorType = error instanceof NotFoundError ? ERROR_TYPE.NOT_FOUND : ''

            return <ErrorPage type={errorType} />
        }

        return <>{this.props.children}</>
    }
}
